import { render, staticRenderFns } from "./producto.vue?vue&type=template&id=51ccbe60&"
import script from "./producto.vue?vue&type=script&lang=js&"
export * from "./producto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports